<template>
    <div class="leave">
        <div class="main modal_body scroll_bar">
            <el-form label-position="top" :inline="true" ref="woForm">
                <div v-if="extendsField.length > 0">
                    <div v-for="item in extendsField">
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 1">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-input @input="change" clearable v-model="item.chooseValue" style="width: 100%" type="text"
                                      :placeholder="$t('input')"/>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 2">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-input @input="change" clearable v-model="item.chooseValue" style="width: 100%" type="textarea"
                                      :placeholder="$t('input')"/>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 3">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName}}</span>
                            </div>
                            <el-date-picker @input="change"  v-model="item.chooseValue" type="date" style="width: 100%"
                                            value-format="yyyy-MM-dd"
                                            :placeholder="$t('select')" align="right">
                            </el-date-picker>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 4">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-date-picker @input="change"  style="width: 100%" type="datetime" v-model="item.chooseValue"
                                            format="yyyy-MM-dd HH:mm"
                                            :placeholder="$t('select')" align="right">
                            </el-date-picker>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 5">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-input-number @input="change" clearable style="width: 100%" v-model="item.chooseValue" type="textarea"
                                             :placeholder="$t('input')"/>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 6">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-select @change="change" style="width: 100%" :placeholder="$t('input')" v-model="item.chooseValue">
                                <el-option v-for="val in item.fieldValue" :key="val.name" :label="val.name"
                                           :value="val.name"/>
                            </el-select>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 7">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-radio-group @change="change" v-model="item.chooseValue">
                                <el-radio v-for="val in item.fieldValue" :key="val.name" :label="val.name"
                                          :value="val.name">{{ val.name }}
                                </el-radio>
                            </el-radio-group>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 8">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-checkbox-group @change="change" v-model="item.chooseValue">
                                <el-checkbox v-for="val in item.fieldValue" :key="val.name" :label="val.name">
                                    {{ val.name  }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="form_item" :key="item.fieldId" v-if="item.fieldType === 9">
                            <div class="label">
                                <span v-if="item.requiredStatus" class="red">*</span>
                                <span> {{ item.fieldName }}</span>
                            </div>
                            <el-cascader @change="change" :options="item.fieldValue" :props="optionProps2" filterable ref="zdy"/>
                        </div>
                    </div>
                </div>
            </el-form>
            <el-button class="submitBtn" type="primary" @click="sendMessage">{{ $t("submitLeave") }}</el-button>
        </div>
    </div>
</template>

<script>
import {Toast} from "mint-ui";
import urlParams from "../../api/urlParams";
import request from "../../api/request";
import store from "../../store";

export default {
    name: "h5Form",
    data() {
        return {
            isIframe: false,
            active: "create",
            fileList: [],
            email: "",
            list: [],
            extendsField: [],
            Field: [],
            optionProps2: {
                value: "id",
                label: "name",
                children: "children",
            },
            showFlag: false,
            orderDetail: {},
            typeId: "",
            typeName: "",
        };
    },
    watch: {
        initData() {
            return this.$store.state.initData;
        },
    },
    computed: {
        initData() {
            return this.$store.state.initData;
        },
    },
    mounted() {
        this.getTemplateFiled({id: this.$route.query.templateId});
    },
    methods: {
        formDate(value, fmt) {
            if (!value) {
                return "--";
            }
            fmt = fmt || "yyyy-MM-dd hh:mm:ss";
            if (value && value < 10000000000) {
                value = value * 1000;
            }

            let getDate = new Date(value * 1);
            let o = {
                "M+": getDate.getMonth() + 1,
                "d+": getDate.getDate(),
                "h+": getDate.getHours(),
                "m+": getDate.getMinutes(),
                "s+": getDate.getSeconds(),
                "q+": Math.floor((getDate.getMonth() + 3) / 3),
                S: getDate.getMilliseconds(),
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(
                    RegExp.$1,
                    (getDate.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                    );
                }
            }
            return fmt;
        },
        // 发送留言
        sendMessage() {
            var param = {
                cusFieldConfigInfoVoList: [],
                partnerId: "",
                userId: store.state.userInfo.userId || urlParams("userId"),
                tenantId: store.state.initData.tenantId || urlParams("tenantId"),
                woFileRelVoList: [],
                woStartWay: 0,
                woTitle: "卡片提交工单",
                woType: "",
                woTypeId: this.$route.query.templateId,
                woTypeName: '卡片表单',
                woContent:'表单跳转提交的工单',
            };
            if (this.extendsField.length > 0) {
                for (let i = 0; i < this.extendsField.length; i++) {
                    if (this.extendsField[i].requiredStatus && this.extendsField[i].chooseValue == "") {
                        // 必填评价
                        Toast({
                            message: this.$t("pleInput") + this.extendsField[i].fieldName,
                            duration: 3000,
                        });
                        return;
                    }
                   
                        param.cusFieldConfigInfoVoList.push({
                            fieldId: this.extendsField[i].fieldId,
                            fieldValue: this.extendsField[i].chooseValue,
                            fieldName: this.extendsField[i].fieldName,
                        });
                }
            }
    
            request.addWo(param).then((res) => {
                Toast({
                    message: this.$t("submitSuc"),
                    duration: 2000,
                });
            });

        },
        getTemplateFiled(param) {
            request.queryWoTypeInfoItem(param).then(result => {
                if (result.code === 200) {
                    this.extendsField = result.data.items
                    this.extendsField.forEach(item => {
                        if (item.fieldType === 7 || item.fieldType === 6 || item.fieldType === 8 || item.fieldType === 9) {
                            item.fieldValue = JSON.parse(item.fieldValue);
                        }
                        if (item.fieldType === 5) {
                            item.chooseValue = 0
                        } else if (item.fieldType === 8) {
                            item.chooseValue = []
                        } else {
                            item.chooseValue = '';
                        }
                    })
                }
            })
        },
        change(){
            this.$forceUpdate()
        }
    },
};
</script>

<style scoped>
.leave {
    width: 100%;
    height: 100%;
    background: #fff;
}

.main {
    padding: 15px;
}

strong {
    color: red;
}
.items .label {
    font-size: 14px;
    color: #5a5a5a;
    line-height: 28px;
    text-align: left;
    margin-bottom: 10px;
}

.modal_body {
    padding: 20px 10px 20px 15px;
    flex: 1;
    height: 94vh;
    max-height: 94vh;
    box-sizing: border-box;
}

.form_item > div {
    display: block;
    /* width: 80px; */
    vertical-align: middle;
    color: #666666;
}

.form_item {
    display: block;
    align-items: center;
    margin: 15px auto;
    width: 80%;
    text-align: left;
}

.label {
    margin-bottom: 10px;
    font-size: 14px;
}

textarea {
    flex: 1;
    resize: none;
    height: 42px;
    width: 440px;
    vertical-align: text-top;
    padding: 8px;
    border: 1px solid #e6e6e6;
    outline: none;
    color: #535151;
}

button {
    width: 180px;
    height: 32px;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    border: none;
}



button {
    margin-top: 20px;
}


.submitBtn {
    display: block;
    width: 78%;
    height: 44px;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(to right, rgb(45, 180, 249), rgb(39, 46, 220));
    border: none;
    border-radius: 40px;
    font-size: 17px;
    margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/formData/pc.vue